// A customer's billing rate is either a shared rentalRates doc (referenced by
// id) or a rate that exists only on that customer. CUSTOM_RATE is the sentinel
// stored in billingRateId for the latter — it is deliberately not a valid
// Firestore id, so a lookup against rentalRates can never match it by accident.
export const CUSTOM_RATE = '__custom__';

// Returns a rate-shaped object for a customer, or null when they have none.
// Shape matches a rentalRates doc so pricing can treat both the same way.
export function customerRate(cust, rentalRates = []) {
  if (!cust || !cust.billingRateId) return null;
  if (cust.billingRateId === CUSTOM_RATE) {
    if (cust.billingRateHourly == null && cust.billingFacilityRate == null) return null;
    return {
      id: CUSTOM_RATE,
      rateName: cust.billingRateName || 'Custom rate',
      hourlyRate: cust.billingRateHourly ?? 0,
      facilityRate: cust.billingFacilityRate ?? null,
      custom: true,
    };
  }
  return rentalRates.find(r => r.id === cust.billingRateId) || null;
}
